import { ChainId } from '@pancakeswap/sdk'

import { pools as kasplexTestnetPools, livePools as kasplexTestnetLivePools } from './167012'
import { pools as igraTestnetPools, livePools as igraTestnetLivePools } from './19416'
import { pools as kasplexMainnetPools, livePools as kasplexMainnetLivePools } from './202555'
import { SerializedPool } from '../../types'
import { SupportedChainId } from '../supportedChains'
import { isPoolsSupported } from '../../utils/isPoolsSupported'

export type PoolsConfigByChain<TChainId extends ChainId> = {
  [chainId in TChainId]: SerializedPool[]
}

export const POOLS_CONFIG_BY_CHAIN = {
  [ChainId.KASPLEX_TESTNET]: kasplexTestnetPools,
  [ChainId.IGRA]: igraTestnetPools,
  [ChainId.KASPLEX_MAINNET]: kasplexMainnetPools,
} as PoolsConfigByChain<SupportedChainId>

export const LIVE_POOLS_CONFIG_BY_CHAIN = {
  [ChainId.KASPLEX_TESTNET]: kasplexTestnetLivePools,
  [ChainId.IGRA]: igraTestnetLivePools,
  [ChainId.KASPLEX_MAINNET]: kasplexMainnetLivePools,
} as PoolsConfigByChain<SupportedChainId>

export const getPoolsConfig = (chainId: ChainId) => {
  if (!isPoolsSupported(chainId)) {
    return undefined
  }
  return POOLS_CONFIG_BY_CHAIN[chainId]
}

export const getLivePoolsConfig = (chainId: ChainId) => {
  if (!isPoolsSupported(chainId)) {
    return undefined
  }
  return LIVE_POOLS_CONFIG_BY_CHAIN[chainId]
}

export const MAX_LOCK_DURATION = 31536000
export const UNLOCK_FREE_DURATION = 604800
export const ONE_WEEK_DEFAULT = 604800
export const BOOST_WEIGHT = 20000000000000n
export const DURATION_FACTOR = 31536000n
